import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Employee, UserRightsDisableReasonModel } from '../../../../models/cloud/cloud.model';



@Component({
  selector: 'deactivate-dialog',
  templateUrl: './deactivate-dialog.component.html',
  styleUrls: ['./deactivate-dialog.component.scss'],
  standalone: false,
})
export class DeactivateDialogComponent implements OnInit {
  reasons: UserRightsDisableReasonModel[];
  selectedReason: number;
  text: string;
  isSubmitted: boolean;

  constructor(
    public dialogRef: MatDialogRef<DeactivateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {user: Employee, disableReason: UserRightsDisableReasonModel[]},
  ) {
    this.reasons = data.disableReason;
    this.reasons?.sort(item => item.Order);

  }

  ngOnInit(): void {
  }

  save(): void {
    this.isSubmitted = true;
    if(!this.selectedReason){
      return;
    }
    this.dialogRef.close({ reasonId: +this.selectedReason, text: this.text, reason: this.reasons.find(r => r.Id === +this.selectedReason)?.Text });
  }

  getReason($event: any): void {
    this.selectedReason = $event;
  }

  matDialogClose(): void {
    this.dialogRef.close();
  }
}
